import React, { useState } from "react";
import classNames from "classnames";
import styles from "./CheckActions.module.css";
import PopupHeader from '../PopupHeader';

import cancel from "../../../../assets/images/Fireboard/action_buttons/cancel_white.png";
import done from "../../../../assets/images/Fireboard/action_buttons/done_white.png";
import inprogress from "../../../../assets/images/Fireboard/action_buttons/inprogress_white.png";
import joincheck from "../../../../assets/images/Fireboard/action_buttons/joincheck_white.png";
import location from "../../../../assets/images/Fireboard/action_buttons/location_white.png";
import markaspaid from "../../../../assets/images/Fireboard/action_buttons/markaspaid_white.png";
import markaspaidEuro from "../../../../assets/images/Fireboard/action_buttons/markaspaidEuro.png";
import preauth from "../../../../assets/images/Fireboard/action_buttons/preauth_white.png";
import scantopay from "../../../../assets/images/Fireboard/action_buttons/scantopay_white.png";
import sms from "../../../../assets/images/Fireboard/action_buttons/sms_white.png";
import sync from "../../../../assets/images/Fireboard/action_buttons/sync_white.png";
import texttopaydollar from "../../../../assets/images/Fireboard/action_buttons/texttopay_white.png";
import texttopayeuro from "../../../../assets/images/Fireboard/action_buttons/texttopayeuro_white.png";

const col1Buttons = [
  {
    type: "done",
    icon: done,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as Done",
  },
  {
    type: "paid",
    icon: markaspaid,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Mark as Paid",
  },
  {
    type: "moveToInprogress",
    icon: inprogress,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Move to Inprogress",
  },
  {
    type: 'preAuth',
    icon: preauth,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Pre Auth",
  },
  {
    type: "resync",
    icon: sync,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Sync Check",
  },
  {
    type: "cancel",
    icon: cancel,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Cancel Order",
  },
];

const col2Buttons = [
  {
    type: "sms",
    icon: sms,
    style: styles.doneBtn,
    imgStyle: styles.buttonHeight,
    name: "Notify Guest",
  },
  {
    type: "checkIn",
    icon: location,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Text to Check In",
  },
  {
    type: "textToPay",
    icon: texttopaydollar,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Text to Pay",
  },
  {
    type: "qrscan",
    icon: scantopay,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Scan to Pay",
  },
  {
    type: "joinCheck",
    icon: joincheck,
    style: styles.printStyle,
    imgStyle: styles.buttonHeight,
    name: "Join Check",
  },
  // {
  //   type: "print",
  //   icon: print,
  //   style: styles.printStyle,
  //   imgStyle: styles.buttonHeight,
  //   name: "Print Receipt",
  // },
];

export default function CheckActions(props) {
  const {
    updateOrderStatus,
    markItemAPaid,
    onQRGenerate,
    selectCheck,
    onHandleSms,
    onHandleTextToPay,
    textToCheckIn,
    selectedItem: item,
    onResyncCheck,
    managerMode,
    onPreAuth,
    dismissPopup,
    currency = '$',
    joinCheck,
  } = props;

  const [selectedAction, setSelectedAction] = useState("");


  const displayPreAuth = item => {
    const {selectedCheckDetails} = item;
    const { tickets } = selectedCheckDetails || {};
    let showPreAuthIcon;
    if (!managerMode) return false;
    if (Array.isArray(tickets) && tickets.length) {
      tickets.forEach(ticket => {
        const { ticketStatusId, preAuth } = ticket || {};
        if (ticketStatusId === 0 && preAuth && item.unpaidAmount > 0) {
          showPreAuthIcon = true;
        }
      });
    } else {
      showPreAuthIcon = false;
    }
    return showPreAuthIcon;
  };

  const handleValidations = (type, item) => {
    const excludeCheck = item.orderStatusId !== 5 && item.orderStatusId !== 8;
    switch (type) {
      case "cancel":
        return excludeCheck;
      case "done":
        return (
          ((item.orderStatusId === 1 || item.orderStatusId === 0) && item.unpaidAmount === 0) ||
          item.orderStatusId === 5 ||
          item.orderStatusId === 8 ||
          item.orderStatusId === 9
        );
      case "sms":
        return (
          ((item.orderStatusId === 1 || item.orderStatusId === 0) && item.unpaidAmount === 0) ||
          (item.unpaidAmount > 0 && excludeCheck)
        );
      case "qrscan":
        return item.unpaidAmount > 0 && excludeCheck;
      case "textToPay":
        return item.unpaidAmount > 0 && excludeCheck;
      case "checkIn":
        return excludeCheck;
      case "paid":
        return item.unpaidAmount > 0 && item.sourceType !== 0 && excludeCheck;
      case "resync":
        return true;
        case 'preAuth':
          return displayPreAuth(item) && excludeCheck;
      case "moveToInprogress":
        return item.orderStatusId === 0;
      case "joinCheck": 
          return item.sourceType === 0 && item.open;
      default:
        break;
    }
  };

  const handleActions = (type, item) => {
    switch (type) {
      case "cancel":
        updateOrderStatus(item, "cancel");
        break;
      case "done":
        updateOrderStatus(item, "done");
        break;
      case "sms":
        onHandleSms(item);
        selectCheck(item);
        break;
      case "qrscan":
        onQRGenerate(item);
        selectCheck(item);
        break;
      case "textToPay":
        onHandleTextToPay(item, false);
        break;
      case "checkIn":
        textToCheckIn(item, false);
        break;
      case "paid":
        markItemAPaid(item);
        break;
      case "resync":
        onResyncCheck(item);
        break;
        case "preAuth":
          onPreAuth(item);
          break;
      case "moveToInprogress":
        updateOrderStatus(item, "moveToInprogress");
        break;
      case "joinCheck":
        joinCheck(item);
        selectCheck(item);
        break;
      default:
        break;
    }
  };

  const renderActionsButtons = (eachButton) => {
    const enabled = handleValidations(eachButton.type, item);
    let src = eachButton.icon;
    if (currency === '£' && eachButton.type === 'textToPay')
      src = texttopayeuro;
    if (currency === '£' && eachButton.type === 'paid')
      src = markaspaidEuro;
    return (
      <div
        key={eachButton.type}
        className={classNames({ [`${styles.innerContainer}`]: true, [`${styles.highligthtedAction}`]: selectedAction === eachButton.type, [styles.disabledButton]: !enabled })}
        onMouseEnter={() => setSelectedAction(eachButton.type)}
        onMouseLeave={() => setSelectedAction("")}
        onClick={() => enabled && handleActions(eachButton.type, item)}
      >
        <div className={styles.imgWrapper}>
          <img src={src} className={styles.icon} alt="icon" />
        </div>
        <span className={classNames({ [styles.buttonName]: true, [styles.disabledTxt]: !enabled })}>{eachButton.name}</span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <PopupHeader title='' onClose={dismissPopup} containerStyle={styles.heading} />
      <div className={styles.buttonsContainer}>
        <div className={styles.column}>
          {col1Buttons.map((eachButton) =>
            renderActionsButtons(eachButton)
          )}
        </div>
        <div className={styles.column}>
          {col2Buttons.map((eachButton) =>
            renderActionsButtons(eachButton)
          )}
        </div>
      </div>
    </div>
  );
}
